module.exports = __webpack_public_path__ + "static/media/play-board-intro-1.eaf564ed.png";